// extracted by mini-css-extract-plugin
export default {"section":"Summary_section__r4T+L","page-navigation":"Summary_page-navigation__xD+LB"};